module.exports = __webpack_public_path__ + "img/opimize_primary.e3e1f8cd.svg";